import { useEffect } from "react";

/**
 * Locks background page scroll while a modal/overlay is open, so mouse-wheel
 * scrolling over the modal scrolls the modal's own content instead of the
 * page behind it. Pass `active=false` (or omit) to skip locking.
 */
export function useLockBodyScroll(active = true) {
  useEffect(() => {
    if (!active) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [active]);
}

export default useLockBodyScroll;
